import { VIDEO_TEMPLATE_ROUTE } from '@anm/constants/routes';
import { LinkContext } from '@anm/contexts/LinkContext';
import CATEGORIES from '@anm/data/video-templates/header-categories';
import capitalize from '@anm/helpers/string/capitalize';
import usePageParams from '@anm/hooks/usePageParams';
import { useCallback, useContext, FC } from 'react';

import CategoryRow from './CategoryRow';
import { CategoryItem, ContainerWrapper } from './Wrapper';

const FooterCategories: FC = () => {
  const { Link } = useContext(LinkContext);
  const { embed } = usePageParams();

  const renderCategoryLink = useCallback(
    ({ label, page, pageCategory, isOwnCategory }) => {
      const route = VIDEO_TEMPLATE_ROUTE;
      const pageName = isOwnCategory ? page : `${pageCategory}-${page}`;
      const params = {
        pageName,
        ...(embed && { embed })
      };

      return (
        <Link key={label} {...{ route, params }}>
          <CategoryItem>{capitalize(label)}</CategoryItem>
        </Link>
      );
    },
    [embed]
  );

  return (
    <ContainerWrapper size={1230}>
      {CATEGORIES.map(({ label, list, page }) => (
        <CategoryRow
          key={label}
          pageCategory={page}
          {...{ list, label, renderCategoryLink }}
        />
      ))}
    </ContainerWrapper>
  );
};

export default FooterCategories;
